export function roundOffNumericText(value: string | number, roundOff?: number): string {
  const text = String(value);
  if (roundOff === undefined || text.trim() === '' || !Number.isFinite(Number(text))) return text;
  return Number(text).toFixed(roundOff);
}

export function optionalProperty<T extends string, U>(key: T, value: U | undefined | null): Record<T, U> | {} {
  if (value === undefined || value === null || (Array.isArray(value) && value.length === 0) || Number.isNaN(value))
    return {};
  return { [key]: value };
}
